import React from 'react';
import { Button } from 'elmo-elements';
import './VideoSlideCanvas.scss';
import config from '@/lib/config';

interface VideoSlideCanvasPropsType {
  browseAsset: () => void;
  browseVocamVideo: () => void;
  hasVideoLibrary?: boolean;
}
const VideoSlideCanvas = ({
  browseAsset,
  browseVocamVideo,
  hasVideoLibrary = false,
}: VideoSlideCanvasPropsType): React.ReactElement => (
  <div className="vocam-video-container">
    <div className="vocam-video-items">
      <img
        id="video-preview-thumbnail"
        src={`${config.assetPath}img-video-only.svg`}
        alt="video-icon"
      />
      <div className="video-preview-info">
        <p className="video-preview-info-header">No video to display</p>
        <p className="video-preview-info-description">
          A preview will be generated once a video is selected
        </p>
      </div>
      <div className="vocam-video-browse-container">
        <Button
          className="video-slide-buttons"
          type="default"
          isUppercase={false}
          onClick={browseAsset}
        >
          Browse Asset Library
        </Button>
        {hasVideoLibrary && (
          <Button
            className="video-slide-buttons"
            type="default"
            isUppercase={false}
            onClick={browseVocamVideo}
          >
            Browse Video Library
          </Button>
        )}
      </div>
    </div>
  </div>
);

export default VideoSlideCanvas;
